import { Box, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react"
import ListOfHelpers from "./ListOfHelpers";
import HelpRequesterMap from "./HelpRequesterMap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { menuActive  } from '../../store/menuSlice';
import { useEffect } from "react";

import { GrMapLocation } from "react-icons/gr";
import { AiOutlineAlert } from "react-icons/ai";

import { sxBtnSelect, sxBtnSelectA, sxBtnSelectB } from "../../components/ButtonCustomize";

export default function HelperInformation() {
    const location = useLocation()
    const navigate = useNavigate()
    const [value, setValue] = useState(0);
    const dispatch = useDispatch()

    if (!location.state) {
        location.state = { value: 0 }
    }

    useEffect(() => {
        dispatch(menuActive('รับแจ้งเหตุฉุกเฉิน'))
    },[])

    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'start',
                gap: 6,
                mt: 1, mb: 2, ml: '3rem',
                '@media (max-width: 512px)': {
                    justifyContent: 'center',
                    gap: 3,
                    pr: 1.25,
                    ml: 3,
                }
            }}>

                <Tooltip title="แผนที่">
                    <IconButton onClick={() => { setValue(0); navigate("/auth/helperInformation", { state: { value: 0 } }); }} aria-label="Map" size="large" color="c_button"
                        {...(location.state.value === 0 && sxBtnSelect)}
                    >
                        <GrMapLocation/>
                    </IconButton>
                </Tooltip>

                <Tooltip title="รายชื่อผู้ขอความช่วยเหลือ">
                    <IconButton onClick={() => { setValue(1); navigate("/auth/helperInformation", { state: { value: 1 } }); }} aria-label="Emergency List" size="large" color="c_button"
                        {...(location.state.value === 1 && sxBtnSelect)}
                    >
                        <AiOutlineAlert/>
                    </IconButton>
                </Tooltip>

            </Box>

            {location.state.value === 0 && <HelpRequesterMap />}
            {location.state.value === 1 && <ListOfHelpers />}
        </>
    )
}